import { baseUrl, apiKey } from '@/config';
import { APP_KEY_ACCESS } from '@/constants/appKeyAccess';

export class CmsService {
  static async getSettingsAll() {
    try {
      const response = await fetch(`${baseUrl}/cms/settings/all`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-signature': apiKey || '',
        },
        cache: 'no-store',
      });

      if (!response.ok) {
        console.error('Error fetching CMS settings:', response.status);
        return {};
      }

      const result = await response.json();

      if (result.success && result.data) {
        return result.data;
      }

      return {};
    } catch (error) {
      console.error('Error fetching CMS settings:', error);
      return {};
    }
  }

  static async verifyAccessTicket({ ticket, shortcode }) {
    try {
      const params = new URLSearchParams();
      params.set('ticket', String(ticket || ''));
      params.set('shortcode', String(shortcode || ''));

      const response = await fetch(`/wp-json/keobongvip/v1/verify-access-ticket?${params.toString()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        cache: 'no-store',
      });

      if (!response.ok) {
        return { success: false, data: null };
      }

      return await response.json();
    } catch (error) {
      console.error('Error verifying access ticket:', error);
      return { success: false, data: null };
    }
  }

  static async checkAccessKey(key) {
    try {
      const safeKey = String(key || APP_KEY_ACCESS?.defaultKey || 'FREE').trim();
      const response = await fetch(`${baseUrl}/cms/check-key?key=${encodeURIComponent(safeKey)}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-signature': apiKey || '',
        },
        cache: 'no-store',
      });

      if (!response.ok) {
        return { success: false, data: null };
      }

      return await response.json();
    } catch (error) {
      console.error('Error checking CMS access key:', error);
      return { success: false, data: null };
    }
  }
}
